import { render, staticRenderFns } from "./dealerindex.vue?vue&type=template&id=2150835a&scoped=true&"
import script from "./dealerindex.vue?vue&type=script&lang=js&"
export * from "./dealerindex.vue?vue&type=script&lang=js&"
import style0 from "./dealerindex.vue?vue&type=style&index=0&id=2150835a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150835a",
  null
  
)

export default component.exports